import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./Cta";

export const StickyBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.75);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-conversion-bar"
          initial={{ y: 96 }}
          animate={{ y: 0 }}
          exit={{ y: 96 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0A111E]/90 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3.5 sm:px-6">
            <div className="font-display">
              <span className="mr-2.5 text-sm text-slate-500 line-through">$500</span>
              <span className="text-xl font-extrabold text-slate-50 sm:text-2xl">$297 USD</span>
            </div>
            <CtaButton size="sm" testId="sticky-cta-button">
              Inscribirme
            </CtaButton>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
